<!--
 * @Author: chenxing
 * @Date: 2021-03-17 17:27:16
 * @LastEditors: chenxing
 * @LastEditTime: 2021-03-31 16:40:37
-->
<template>
  <a-result status="404" title="404" sub-title="你所访问的页面不存在">
    <template #extra>
      <a-button type="primary" @click="toHome">
        回到首页
      </a-button>
    </template>
  </a-result>
</template>

<script>
export default {
  name: 'Exception404',
  methods: {
    toHome () {
      this.$router.push({ path: '/' });
    }
  }
};
</script>
